export const getGender = (genderType) => {
  return genderType === "FEMALE" ? "Nữ" : "Nam";
};
